"use strict";

var _interopRequireDefault = require("/root/www/xmg-cms-fe/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBigCatList = getBigCatList;

var _request = _interopRequireDefault(require("@/utils/request"));

function getBigCatList(params) {
  return (0, _request.default)({
    url: '/cat/xcx-list',
    method: 'get',
    params: params
  });
}